import React from "react";

const ForeignWaves = ({ className }) => {
  return (
    <svg
      className={className}
      width="1440"
      height="400"
      viewBox="0 0 1440 400"
      preserveAspectRatio="none"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_332_13107)">
        <rect width="1441" height="440" fill="white" />
        <path
          opacity="0.28"
          d="M45.0575 254.616C15.219 286.826 -35.0809 288.748 -67.2905 258.91C-99.5001 229.071 -101.422 178.772 -71.5839 146.562C-41.7455 114.352 8.55442 112.43 40.764 142.268C72.9737 172.107 74.8959 222.407 45.0575 254.616ZM-67.0811 150.733C-94.6158 180.456 -92.842 226.872 -63.1192 254.407C-33.3964 281.942 13.02 280.168 40.5546 250.445C68.0893 220.722 66.3155 174.306 36.5927 146.771C6.86992 119.237 -39.5464 121.01 -67.0811 150.733Z"
          fill="#7F4A9B"
        />
        <path
          opacity="0.28"
          d="M133.96 386.729C42.0048 485.991 -113.007 491.915 -212.27 399.96C-311.532 308.005 -317.456 152.993 -225.501 53.7304C-133.546 -45.5319 21.4661 -51.4558 120.728 40.4992C219.991 132.454 225.915 287.466 133.96 386.729ZM-205.285 72.4579C-286.897 160.555 -281.64 298.132 -193.542 379.744C-105.445 461.356 32.132 456.099 113.744 368.001C195.356 279.904 190.099 142.327 102.001 60.7149C13.9034 -20.8972 -123.673 -15.6396 -205.285 72.4579Z"
          fill="#7F4A9B"
        />
        <path
          opacity="0.28"
          d="M80.7087 326.493C18.7798 393.343 -85.6162 397.333 -152.466 335.404C-219.317 273.475 -223.306 169.079 -161.377 102.229C-99.4484 35.3788 4.94765 31.3893 71.7978 93.3181C138.648 155.247 142.638 259.643 80.7087 326.493ZM-152.032 110.886C-209.179 172.575 -205.498 268.911 -143.809 326.059C-82.1201 383.206 14.2158 379.524 71.3632 317.836C128.511 256.147 124.829 159.811 63.1403 102.664C1.45152 45.5162 -94.8843 49.1977 -152.032 110.886Z"
          fill="#7F4A9B"
        />
        <circle cx="1277" cy="330" r="262" fill="#4C0075" />
        <path
          d="M1115 120.5C1256.2 14.5003 1395.83 84.4004 1446.5 130.234V545.234L977 555.734C1017 371.734 1190.5 345.734 1259.5 293.734C1314.7 252.134 1236.5 229.4 1190.5 223.234C1126.9 226.834 1112.67 154.667 1115 120.5Z"
          fill="#7F4A9B"
          stroke="url(#paint0_linear_332_13107)"
          stroke-width="3"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_332_13107"
          x1="1152.51"
          y1="103.366"
          x2="1431.56"
          y2="368.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <clipPath id="clip0_332_13107">
          <rect width="1441" height="440" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ForeignWaves;
